<template>
  <el-collapse-item
    title="Company Info"
    name="company_info"
  >
    <p>
      <strong>Organization Name: </strong>
      <span>{{ profile.organization.name }}</span>
    </p>
    <p>
      <strong>Assessments Left: </strong>
      <span>{{ profile.availableLinks }}</span>
    </p>
    <p>
      <strong>Created Date: </strong>
      <span>{{ displayDate(profile.createdDate) }}</span>
    </p>
    <p>
      <strong>Expiration Date: </strong>
      <span>{{ displayDate(profile.expirationDate) }}</span>
    </p>
    <p>
      <strong>Status: <span :class="profile.status">{{ profile.status }}</span></strong>
    </p>
    <MakeAccountTurkish :profile="profile" v-if="!isTurkish"/>
  </el-collapse-item>
</template>

<script>
import MakeAccountTurkish from '@/components/UserDrawer/Sections/Actions/MakeAccountTurkish.vue';

export default {
  name: 'CompanyInfo',
  components: { MakeAccountTurkish },
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  computed: {
    isTurkish() {
      return this.$store.getters.isTurkish
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .PAID { color: $-color-success; }
  .FREE { color: $-color-warning; }
  .EXPIRED { color: $-color-error; }
</style>
